export class TerminalOwner {
	TerminalID:string;
	CompanyID:string;
	Type:string;
	NickName:string;

	public constructor(data:any){
		this.TerminalID = data.TerminalID;
		this.CompanyID = data.CompanyID;
		this.Type = data.Type;
		this.NickName = data.NickName;
	}

	public toString():string {
		if (this.NickName) {
			return `${this.NickName} (${this.TerminalID} / ${this.Type})`;
		}
		return `${this.TerminalID} (${this.Type})`;
	}

}